
import React, { useEffect, useRef, useState } from "react";
import "./HomeUpcomingCoursesSection.css";
import { getLanguage } from 'react-switch-lang';
import en from '../en.json';
import ma from '../ma.json';


import shareIcon from "../assets/icons/share.svg";

import {

  buildDeepLink,
  shareDeepLink
} from "../utils/deepLink";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import * as myConstClass from "../constant";
const newlyWedIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279698/Suprajanan_Newly_Wed_Couples_e0p3gt.png';
const birthUpTo7Icon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279698/Nurturing_Kids_Birth_up_to_7_years_xe0ajs.png';
const stressManagementIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279698/Stress_Management_mh1fiq.png';
const healthCareIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279699/Health_Care_1_qunv8g.png';
const lifeAfterDeathIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279699/Life_after_Death_dnb210.png';
const meditationYogaIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279699/Meditation_Yoga_ijktju.png';
const PrenatalIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279701/Garbha_Sanskar_Prenatal_Education_1_vwf2af.png';
const ChildDevIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279701/Child_Development_8_to_14_years_jprffn.png';
const scienceOfSpiritualityIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1775279698/Science_of_Spirituality_jzwya1.png';
const fifteenToTwentyEightIcon = 'https://res.cloudinary.com/dtuy184dc/image/upload/v1777011140/Youth_Power_15_to_28_years_1_kkb3ar.png';
const translationData = { en: en, mr: ma };
  // Truncate title for mobile view
  const getTruncatedTitle = (title) => {
    if (!title) return "";
    return title.length > 30 ? title.substring(0, 30) + "..." : title;
  };

const HomeUpcomingCoursesSection = () => {
  const sliderRef = useRef(null);
  const [events, setEvents] = useState([]);
  const history = useHistory();
  const delay = (ms) => new Promise(res => setTimeout(res, ms));
  const safeFetch = async (url) => {
  try {
    const res = await fetch(url);

    if (res.status === 429) return null; // ignore rate limit
    if (!res.ok) return null;

    const text = await res.text();
    if (text.startsWith("<")) return null;

    return JSON.parse(text);
  } catch {
    return null;
  }
};
  // Read language from localStorage key "key" (set by the header) OR from react-switch-lang cookie
  const getActiveLang = () => {
    const lsKey = localStorage.getItem('key');
    if (lsKey) return lsKey;
    return getLanguage() || 'en';
  };

  const [language, setLanguage] = useState(() => getActiveLang());
  const t = (key) => {
    const langKey = language === 'ma' || language === 'mr' ? 'mr' : 'en';
    return translationData[langKey]?.[key] || '';
  };
  useEffect(() => {
    const checkLang = () => {
      const current = getActiveLang();
      setLanguage(prev => prev !== current ? current : prev);
    };
    checkLang();
    // Poll at 300ms to catch header language changes on the same tab
    const interval = setInterval(checkLang, 2000);
    window.addEventListener('storage', checkLang);
    window.addEventListener('languageChange', checkLang);
    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', checkLang);
      window.removeEventListener('languageChange', checkLang);
    };
  }, []);

  /* ================= FETCH ================= */
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Use the selected language for fetching events
        const langKey = language === 'ma' || language === 'mr' ? 'mr' : 'en';
        const res = await fetch(
          `${myConstClass.NODE_API_BASE}/calendar/list/${langKey}/0/0/1/all`
        );
        const data = await res.json();

        if (data.status === "true") {
            const eventsList = data.data.slice(0, 6);
            const enrichedEvents = await Promise.all(
            eventsList.map(async (event, index) => {              const eventId =
                event.eventId ||
                (event.arrSchedule && event.arrSchedule[0]?.eventId);

              let infoData = null;
              let scheduleData = null;

              try {
                await delay(index * 50);

                [infoData, scheduleData] = await Promise.all([
                  safeFetch(`${myConstClass.NODE_API_BASE}/event/getEventInfo/${eventId}`),
                  safeFetch(`${myConstClass.NODE_API_BASE}/event/getEventSchedule?event_id=${eventId}&language=en`)
                ]);
              } catch {}

              // 👉 SAFE FALLBACKS (VERY IMPORTANT)
              const topicName =
                langKey === 'mr'
                  ? infoData?.data?.topics?.[0]?.titleMr || event.topicName || ""
                  : infoData?.data?.topics?.[0]?.titleEn || event.topicName || "";

              const topicNameEn = infoData?.data?.topics?.[0]?.titleEn || event.topicName || "";

              const eventTitle =
                langKey === 'mr'
                  ? infoData?.data?.event?.titleMr || event.title || ""
                  : infoData?.data?.event?.titleEn || event.title || "";

              const description =
                langKey === 'mr'
                  ? infoData?.data?.event?.descriptionHtmlMr || event.description || ""
                  : infoData?.data?.event?.descriptionHtml || event.description || "";

              let locationCityName = "";
              let locationCityNameMr = "";
              let locationVenueAddr = "";
              let locationVenueAddrMr = "";

              if (scheduleData?.status === 'true') {
                const sched = scheduleData.data?.[0];
                locationCityName = sched?.cityName || event.cityName || "";
                locationCityNameMr = sched?.cityNameMr || event.cityNameMr || "";
                locationVenueAddr = sched?.venueAddress || event.venueAddress || "";
                locationVenueAddrMr = sched?.venueAddressMr || event.venueAddressMr || "";
              }

              return {
                ...event,
                eventId,
                topicName,
                topicNameEn,
                languageId: infoData?.data?.event?.languageId || event.languageId || null,
                description,
                displayTitle: eventTitle,
                locationCityName,
                locationCityNameMr,
                locationVenueAddr,
                locationVenueAddrMr
              };
            })
          );
          setEvents(enrichedEvents);
        }
      } catch (error) {
        console.error("Calendar API Error:", error);
      }
    };

    fetchData();
  }, [language]);

  /* ================= LANGUAGE MAP ================= */

  const getLanguageName = (id) => {
    switch (id) {
      case 1:
        return "English";
      case 2:
        return "Marathi";
      case 3:
        return "Hindi";
      case 4:
        return "Gujarati";
      default:
        return "";
    }
  };

  /* ================= STRIP HTML + LIMIT ================= */

  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const getShortDescription = (html) => {
    if (!html) return "";
    const text = stripHtml(html);
    return text.length > 180
      ? text.substring(0, 50) + "..."
      : text;
  };

  /* ================= DATE FORMAT ================= */

  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return s[(v - 20) % 10] || s[v] || s[0];
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const dayName = date.toLocaleDateString("en-US", { weekday: "short" });
    const monthName = date.toLocaleDateString("en-US", { month: "long" });
    const day = date.getDate();
    return `${dayName}, ${day}${getOrdinal(day)} ${monthName}`;
  };

  const getFormattedDateRange = (schedule) => {
    if (!schedule) return "";
    const duration = Number(schedule.duration);
    const start = formatDate(schedule.startDate);
    const end = formatDate(schedule.endDate);

    if (duration > 1) return `${start} - ${end}`;
    return start;
  };

  /* ================= COLOR LOGIC ================= */

  const getCategoryColor = (topic = "") => {
    const source = topic.toLowerCase();

    if (source.includes("newly wed")) return "blue";
    if (
      source.includes("birth") ||
      ((source.includes("8") || source.includes("eight")) && (source.includes("14") || source.includes("fourteen") || source.includes("to 14") || source.includes("child development")))
    ) return "pink";
    if (
      source.includes("life after death") ||
      source.includes("stress") ||
      source.includes("meditation") ||
      source.includes("yoga")
    )
      return "yellow";
    if (
      source.includes("science") ||
      source.includes("spirituality") ||
      source.includes("health")
    )
      return "purple";
    if (source.includes("15") && source.includes("28"))
      return "green";

    return "blue";
  };

  /* ================= ICON LOGIC ================= */

  const getBackgroundIcon = (topic = "") => {
    const t = topic.toLowerCase();
    // console.log("topic",t);
    if (t.includes("birth")) return birthUpTo7Icon;
    if (t.includes("newly wed")) return newlyWedIcon;
    if (t.includes("stress")) return stressManagementIcon;
    if (t.includes("life after death")) return lifeAfterDeathIcon;
    if (t.includes("meditation") || t.includes("yoga"))
      return meditationYogaIcon;
    if (t.includes("science")) return scienceOfSpiritualityIcon;
    if (t.includes("15") && t.includes("28"))
      return fifteenToTwentyEightIcon;
    if (t.includes("health")) return healthCareIcon;
    if (t.includes("child development")) return ChildDevIcon;
    if (t.includes("Prenatal")) return PrenatalIcon;

    return null;
  };

    const handleShareEvent = async (event, schedule, e) => {
    e.preventDefault();
    e.stopPropagation();

    console.log("Share clicked:", event);

    if (!event?.eventId) {
      toast.error("Unable to share: Event data missing");
      return;
    }

    try {
      const origin = window.location.origin;
      const title = event.title || "Event";

      // Build minimal deep link with only IDs (no title, date, or location)
      const deepLink = buildDeepLink({
        origin,
        eventId: event.eventId,
        schedule_id: schedule?.scheduleId
      });

      const shareData = {
        title: title,
        text: `${title}${schedule?.startDate ? ` - ${schedule.startDate}` : ""}`,
        url: deepLink
      };

      const ok = await shareDeepLink(shareData);

      if (ok) toast.success("Link copied/shared");
    } catch (err) {
      console.error("Share failed", err);
      toast.error("Failed to share link");
    }
  };

  /* ================= SCROLL ================= */

  const scrollRight = () => {
    const slider = sliderRef.current;
    const cardWidth = slider.firstChild.offsetWidth + 30;
    slider.scrollBy({ left: cardWidth, behavior: "smooth" });
  };

  const scrollLeft = () => {
    const slider = sliderRef.current;
    const cardWidth = slider.firstChild.offsetWidth + 30;
    slider.scrollBy({ left: -cardWidth, behavior: "smooth" });
  };

  return (
    <section id="upcoming-courses" className="hm-upcoming-section">
      <div className="hm-upcoming-container">
        <p className="hm-upcoming-eyebrow">{t('upcoming_eyebrow')}</p>
        <h2 className="hm-upcoming-title">
          {t('upcoming_main_title')}
        </h2>

        <div className="hm-upcoming-slider-wrapper">
          <div className="hm-upcoming-slider" ref={sliderRef}>
            {events.map((event, index) => {
              const schedule = event.arrSchedule?.[0];
              const isMarathi = language === 'ma' || language === 'mr';
              const color = getCategoryColor(event.topicNameEn || event.topicName);
              const icon = getBackgroundIcon(event.topicNameEn || event.topicName);
              const shortDesc = getShortDescription(event.description);
              // Use Marathi location fields from getEventSchedule API (same source as EventDetailsPage)
              const cityName = isMarathi
                ? (event.locationCityNameMr || event.locationCityName || schedule?.cityNameMr || schedule?.cityName || '')
                : (event.locationCityName || schedule?.cityName || '');
              const venueAddr = isMarathi
                ? (event.locationVenueAddrMr || event.locationVenueAddr || schedule?.venueAddressMr || schedule?.venueAddress || '')
                : (event.locationVenueAddr || schedule?.venueAddress || '');
              const displayLocation = [cityName, venueAddr].filter(Boolean).join(', ');

              return (
                <div
                  key={index}
                  className={`hm-upcoming-card hm-border-${color}`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    history.push({
                      pathname: `/event_details/${event.eventId}`,
                      state: {
                        selectedScheduleId: schedule?.scheduleId,
                        from: "calendar",
                        viewMode: "list",
                        month: null,
                        year: null
                      }
                    });
                  }}
                >
                  <button className="hm-upcoming-share" onClick={(e) => handleShareEvent(event, schedule, e)}>
                    <img src={shareIcon} alt="share" />
                  </button>

                  <div className={`hm-upcoming-tag hm-tag-${color}`}>
                    {event.topicName}
                  </div>

                  <div className="hm-upcoming-content">

                    <h3 className="hm-upcoming-card-title">
                      {getTruncatedTitle(event.displayTitle)}
                    </h3>

                    {/* SHORT DESCRIPTION */}
                    <p className="hm-upcoming-description">
                      {shortDesc}
                    </p>

                    <p className="hm-upcoming-date">
                      {getFormattedDateRange(schedule)}
                    </p>

                    <p className="hm-upcoming-location">
                      {displayLocation}
                    </p>

                    <div className="hm-upcoming-meta">
                     <i className="far fa-clock clock-icon" aria-hidden="true"></i>{schedule?.duration} Days
                    </div>

                    <div className="hm-upcoming-bottom-row">
                      <span className="hm-upcoming-language">{getLanguageName(event.languageId)}</span>
                      <span className="hm-upcoming-arrow" 
                        onClick={(e) => {
                          e.stopPropagation();
                          history.push({
                            pathname: `/event_details/${event.eventId}`,
                            state: {
                              selectedScheduleId: schedule?.scheduleId,
                              from: "calendar",
                              viewMode: "list",
                              month: null,
                              year: null
                            }
                          });
                        }}
                      >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ marginLeft: "-10px" }}>
                          <path
                            d="M5 12h14M13 5l7 7-7 7"
                            stroke="#9d0b0e"
                            strokeWidth="2.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>

                  {icon && (
                    <div className="hm-upcoming-bg">
                      <img src={icon} alt="" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div className="hm-upcoming-nav hm-upcoming-nav-left" onClick={scrollLeft}>
            <i className="fas fa-chevron-left"></i>
          </div>
          <div className="hm-upcoming-nav" onClick={scrollRight}>
            <i className="fas fa-chevron-right"></i>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeUpcomingCoursesSection;